import instance from '@/apis'

const otc = '/c2c'

// 广告列表
export const search = params => {
  params.adType = params.adType === 1 && 2 || 1
  return instance({
    method: 'get',
    url: otc + '/v3/public/merchant/ad/search',
    params
  })
}

// 广告详情
export const getAdDetail = id => {
  return instance({
    method: 'get',
    url: otc + `/v3/public/merchant/ad/detail/${id}`,
  })
}
export const publishAd = params => {
  return instance({
    method: 'get',
    url: otc + '/v3/public/config/publish-ad',
    params
  })
}
// 创建订单
export const createOrder = params => {
  return instance({
    method: 'post',
    url: otc + `/v3/order/create`,
    data: params
  })
}

// 创建订单新接口
/*export const createOrderNewApi = params => {
  return instance({
    method: 'post',
    url: otc + `/v3/order/proceed`,
    data: params
  })
}*/

// 订单详情
export const orderDetail = id => {
  return instance({
    method: 'get',
    url: otc + `/v3/order/detail/${id}`,
  })
}
// 获取数字货币与法币兑换率
export const exchange = params => {
  return instance({
    method: 'get',
    url: otc + `/v3/public/option/exchange`,
    params
  })
}
// 确认订单标记
export const confirmsOrder = (orderId, paymentId) => {
  return instance({
    method: 'post',
    url: otc + `/v3/order/confirms/${orderId}`,
    params: {paymentId}
  })
}
// 取消订单
export const cancelOrder = (orderId) => {
  return instance({
    method: 'post',
    url: otc + `/v3/order/cancel/${orderId}`,
  })
}
// 检验用户是否能对广告进行下单
export const verifyOrder = (orderId) => {
  return instance({
    method: 'post',
    url: otc + `/v3/order/verify/${orderId}`,
  })
}
// 设置昵称
export const nicknameChange = (data) => {
  return instance({
    method: 'post',
    url: otc + `/v3/user/nickname-change`,
    params: data
  })
}
// 获取下拉枚举
export const getOptionBox = (type) => {
  return instance({
    method: 'get',
    url: otc + `/v3/public/option/box`,
    params: {type}
  })
}
// 获取申诉详情
export const getAppeal = (orderId) => {
  return instance({
    method: 'get',
    url: otc + `/v3/appeal/${orderId}`,
  })
}
// 取消申诉
export const cancelAppeal = (orderId) => {
  return instance({
    method: 'put',
    url: otc + `/v3/appeal/cancel/${orderId}`,
  })
}
// 提交申诉
export const appeal = (orderId, params) => {
  return instance({
    method: 'post',
    url: otc + `/v3/appeal/${orderId}`,
    params
  })
}
// 用户收款方式列表-分类并仅展示账号
export const paymentOptional = (data) => {
  return instance({
    method: 'get',
    url: otc + `/v3/user-payment/optional`,
    data
  })
}
// 发送短信验证码
// export const sendSms = (method, behaviorToken = "") => {
//   return instance({
//     method: 'post',
//     url: `/user/validation/online/${method}`,
//     data: {behaviorToken}
//   })
// }
export const sendSms = (method, behaviorToken = "") => {
  if (method === "phone") method = "sms"
  return instance({
    method: 'post',
    url: `/user/validation/online/${method}`,
    data: {behaviorToken}
  })
}
// 卖方释放虚拟货币/卖方确认收款
export const releaseCC = (orderId, params) => {
  return instance({
    method: 'post',
    url: otc + `/v3/order/release/${orderId}`,
    params
  })
}

// 获得交易配置
export const orderAppealConfig = (params) => {
  return instance({
    method: 'get',
    url: otc + '/v3/public/config/transaction-rule',
  });
}

//获取socket历史消息记录
export const socketHistory = (params) => {
  return instance({
    method: 'get',
    url: otc + '/v3/otc-socket/history',
    params,
    // headers: { 'userId': userId,'orderId': orderId }
  });
}